import React from "react";

interface SuccessModalProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  message?: string;
  buttonText?: string;
  icon?: React.ReactNode;
  iconBgColor?: string;
  buttonColor?: string;
  imageCount: number;
}

export const SuccessModal: React.FC<SuccessModalProps> = ({
  isOpen,
  onClose,
  title,
  message,
  buttonText = "Got it",
  icon,
  iconBgColor = "bg-green-100",
  buttonColor = "bg-green-600 hover:bg-green-700",
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-in fade-in zoom-in duration-200">
        <div className="flex items-start gap-4">
          <div
            className={`flex-shrink-0 w-12 h-12 ${iconBgColor} rounded-full flex items-center justify-center`}
          >
            {icon || (
              <svg
                className="h-6 w-6 text-green-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            )}
          </div>
          <div className="flex-1">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              {title}
            </h3>
            <div className="text-sm text-gray-600 mb-4">{message}</div>
            <div className="flex justify-end">
              <button
                onClick={onClose}
                className={`px-4 py-2 text-sm font-medium text-white rounded-md transition-colors ${buttonColor}`}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
